export default __webpack_public_path__ + "static/media/roomOne.683b4bb1.jpg";